<div class="LCS_rating-stars position-relative">
  <div class="LCS_rating-overlay" *ngIf="isReadOnly"></div>
  <div class="rating-group">
    <ng-container *ngFor="let item of ratingArray; let i = index">
      <ng-container *ngIf="item == 0">
        <label [attr.aria-label]="item + ' stars'" class="rating__label" for="rating_{{name}}-{{item}}-{{i}}">&nbsp;</label>
        <input class="rating__input rating__input--none" checked name="rating_{{name}}" id="rating_{{name}}-{{item}}-{{i}}" value="{{item}}" type="radio">
      </ng-container>

      <ng-container *ngIf="item != 0 && item % 1 != 0">
        <label [attr.aria-label]="item + ' stars'" class="rating__label rating__label--half" for="rating_{{name}}-{{item}}-{{i}}"><i class="rating__icon rating__icon--star fa fa-star-half"></i></label>
        <input class="rating__input" name="rating_{{name}}" [checked]="ratingValue == item" id="rating_{{name}}-{{item}}-{{i}}" value="{{item}}" type="radio">
      </ng-container>

      <ng-container *ngIf="item != 0 && item % 1 == 0">
        <label [attr.aria-label]="item + ' stars'" class="rating__label" for="rating_{{name}}-{{item}}-{{i}}"><i class="rating__icon rating__icon--star fa fa-star"></i></label>
        <input class="rating__input" name="rating_{{name}}" [checked]="ratingValue == item" id="rating_{{name}}-{{item}}-{{i}}" value="{{item}}" type="radio">
      </ng-container>
    </ng-container>
  </div>
</div>